<template>
  <div>
    <template v-if="data != null">
      <v-row no-gutters>
        <v-col cols="12" md="6" class="my-2">
          <div>
            <div style="color: #51c5ce">
              &nbsp;
              <v-icon color="#51c5ce">mdi-view-headline</v-icon>
              <v-icon color="#51c5ce">mdi-home-battery</v-icon>:
              <b> Battery: {{ number }} </b>
            </div>

            <div style="color: #4caf50">
              &nbsp;
              <v-icon color="success">mdi-battery</v-icon>
              <v-icon color="success">mdi-home-battery</v-icon>:
              <b> {{ data.soc }} % </b>
            </div>

            <div style="color: #ffc107">
              &nbsp;
              <v-icon color="warning">mdi-list-status</v-icon>
              <v-icon color="warning">mdi-home-battery</v-icon>:
              <b> {{ data.status }} </b>
            </div>

            <!--             
            // TODO
            crcErrMaskActual: {{ data.crcErrMaskActual }} <br />
            crcErrMaskDelayed: {{ data.crcErrMaskDelayed }} <br />

            <div style="color: #f44336">
              &nbsp;
              <v-icon color="error">mdi-signal</v-icon>
              <v-icon color="error">mdi-home-battery</v-icon>
              <v-icon color="error">mdi-skip-next</v-icon>:
              <b> {{ data.commErrCurrent }} </b>
            </div>

            <div style="color: #f44336">
              &nbsp;
              <v-icon color="error">mdi-signal </v-icon>
              <v-icon color="error">mdi-home-battery</v-icon>
              <v-icon color="error">mdi-skip-previous</v-icon>:
              <b> {{ data.commErrPast }} </b>
            </div> 
            -->
          </div>
        </v-col>

        <v-col cols="12" md="3" class="my-2">
          <div>
            <div :style="getColorTemperature(data.maxTemperature, true)">
              &nbsp;
              <v-icon :color="getColorTemperature(data.maxTemperature, false)">mdi-thermometer-high</v-icon>
              <v-icon :color="getColorTemperature(data.maxTemperature, false)">mdi-home-battery</v-icon>:
              <b> {{ data.maxTemperature }} </b>
              <v-icon :color="getColorTemperature(data.maxTemperature, false)">mdi-temperature-celsius</v-icon>
              ( <i> Index: {{ data.maxTemperatureIndex }} </i> )
            </div>

            <div :style="getColorTemperature(data.avgOfMediansTemperature, true)">
              &nbsp;
              <v-icon :color="getColorTemperature(data.avgOfMediansTemperature, false)">mdi-thermometer-lines</v-icon>
              <v-icon :color="getColorTemperature(data.avgOfMediansTemperature, false)">mdi-home-battery</v-icon>:
              <b> {{ data.avgOfMediansTemperature }} </b>
              <v-icon :color="getColorTemperature(data.avgOfMediansTemperature, false)">mdi-temperature-celsius</v-icon>
            </div>

            <div :style="getColorTemperature(data.minTemperature, true)">
              &nbsp;
              <v-icon :color="getColorTemperature(data.minTemperature, false)">mdi-thermometer-low </v-icon>
              <v-icon :color="getColorTemperature(data.minTemperature, false)">mdi-home-battery</v-icon>:
              <b> {{ data.minTemperature }} </b>
              <v-icon :color="getColorTemperature(data.minTemperature, false)">mdi-temperature-celsius</v-icon>
              ( <i> Index: {{ data.minTemperatureIndex }} </i> )
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3" class="my-2">
          <div>
            <div :style="getColorVoltage(data.cellsMaxVoltage, true)">
              &nbsp;
              <v-icon :color="getColorVoltage(data.cellsMaxVoltage, false)">mdi-gauge-full</v-icon>
              <v-icon :color="getColorVoltage(data.cellsMaxVoltage, false)">mdi-home-battery</v-icon>:
              <b> {{ data.cellsMaxVoltage }} V </b>
              ( <i> Index: {{ data.cellsMaxVoltageIndex }} </i> )
            </div>

            <div :style="getColorVoltage(data.cellsAvgVoltage, true)">
              &nbsp;
              <v-icon :color="getColorVoltage(data.cellsAvgVoltage, false)">mdi-gauge</v-icon>
              <v-icon :color="getColorVoltage(data.cellsAvgVoltage, false)">mdi-home-battery</v-icon>:
              <b> {{ data.cellsAvgVoltage }} V </b>
            </div>

            <div :style="getColorVoltage(data.cellsMinVoltage, true)">
              &nbsp;
              <v-icon :color="getColorVoltage(data.cellsMinVoltage, false)">mdi-gauge-empty </v-icon>
              <v-icon :color="getColorVoltage(data.cellsMinVoltage, false)">mdi-home-battery</v-icon>:
              <b> {{ data.cellsMinVoltage }} V </b>
              ( <i> Index: {{ data.cellsMinVoltageIndex }} </i> )
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="6" md="5" style="color: #8bc34a" align="center">
          <v-icon color="light-green">mdi-battery</v-icon>
          <b> {{ battery.bat.u }} V {{ battery.bat.i }} A</b>
        </v-col>
        <v-col cols="6" md="5" style="color: #8bc34a" align="center">
          <v-icon color="light-green">mdi-current-dc</v-icon>
          <b> {{ battery.dc.u }} V {{ battery.dc.i }} A</b>
        </v-col>
      </v-row>

      <BatteryDigitalSet :data="this.data" />
    </template>
    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import { getColorTemperature, getColorVoltage } from "../../../colors.js";
import BatteryDigitalSet from "../digital/BatteryDigitalSet.vue";

export default {
  name: "Batteries",
  components: {
    BatteryDigitalSet,
  },
  props: {
    number: {
      type: Number,
      require: true,
    },
    data: {
      type: Object,
      require: true,
    },
    battery: {
      type: Object,
      require: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    getColorTemperature,
    getColorVoltage,
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped></style>
